import { Modal } from "frontend/utils/modals/modal";
import { Note } from "frontend/interfaces/note";
import { createNote, updateNote } from "frontend/api/application/request-note";
import { httpPayloadNote } from "frontend/parser/parse-note";
import { ErrorDatabase } from "frontend/uses/use-errors";

import AddNoteComponent from "frontend/components/AddNote.vue";

export interface NoteModalData {
  note: Note;
  editMode: boolean;
  errorDatabase: ErrorDatabase;
  isLoading: boolean;
}

export class NoteModal extends Modal<typeof AddNoteComponent, NoteModalData> {
  protected modalComponent() {
    return AddNoteComponent;
  }

  protected confirmLabel(): "speichern" {
    return "speichern";
  }

  protected async onClose(
    userConfirmed: boolean,
    closeModal: () => void,
    _forceClose = true
  ): Promise<void> {
    super.onClose(userConfirmed, closeModal, false);

    const data = this.getData();
    if (!data) {
      closeModal();
      return;
    }

    if (userConfirmed) {
      try {
        data.isLoading = true;

        const result = data.editMode
          ? await updateNote(httpPayloadNote(data.note))
          : await createNote(httpPayloadNote(data.note));

        this.setSuccess(result.success);

        if (result.success) {
          closeModal();
        } else data.errorDatabase = result.errors;
      } finally {
        data.isLoading = false;
      }
    } else {
      closeModal();
    }
  }
}
